import { render, staticRenderFns } from "./ReportSent.vue?vue&type=template&id=bc2752aa"
import script from "./ReportSent.vue?vue&type=script&lang=js"
export * from "./ReportSent.vue?vue&type=script&lang=js"
import style0 from "./ReportSent.vue?vue&type=style&index=0&id=bc2752aa&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports